import './index.scss';
import LazyImg from '../LazyImg';
import {smartJump} from '@qnpm/vc_jump';
const nop = f => f;
class ProductItem extends React.Component {
    handleClick(data) {
        const {pClick} = this.props;
        const {appUrl, touchUrl} = data.jumpInfo;
        const url = hysdk.sniff.qunar ? appUrl || touchUrl : touchUrl;
        pClick ? pClick(url) : smartJump(url, 'navibar-none');
    }
    render() {
        let {jump, data = {}, btnText='立即购买', scrollContainer='#container',
            pRendeStatus = false, pRend = nop, custCls= '', needShowDate = true,
            needLazy= true} = this.props;
        let reservedDateStr = '';
        if(data.reservedDate && needShowDate) {
            let temp = data.reservedDate.split(',');
            temp = temp.map(item => item && item.split('-'));
            if(temp.length === 2) {
                reservedDateStr = `${temp[0][1]}月${temp[0][2]}日~${temp[1][1]}月${temp[1][2]}日可预约`;
            }
        }
        if(data.status === 2) {
            btnText = '已售罄';
        }
        let showTags = [];
        (data.tagInfos || []).forEach(item => {
            const show = (item.display || '').indexOf('mobile_list') >= 0 && showTags.indexOf(item.title) < 0;
            show && showTags.push(item.title);
        });
        const imgSrc = data.extensionImg || data.thumb;

        return (
            <div className={`pro-item ${custCls}`} onClick={() => {
                if(data.status === 2) return;

                if (jump) {
                    jump();
                    return;
                }
                this.handleClick(data);
            }}>
                <div className="cover">
                    {data.status !== 2 && <div className="top-badge">{data.cornerMark ? data.cornerMark + ' | ' : ''}{data.firstDestination ? data.firstDestination + '·' : ''}{data.functionDisplay}</div>}
                    {reservedDateStr && <div className="bottom-badge">{reservedDateStr}</div>}
                    {
                        imgSrc ?
                            needLazy ?
                                <LazyImg scrollContainer={scrollContainer}>
                                    <img src={imgSrc} alt=""/>
                                </LazyImg> :
                                <img src={imgSrc} alt=""/>
                            : null
                    }

                    {data.status === 2 && <div className="soldout"></div>}
                </div>
                {
                    pRendeStatus ?
                        pRend(data) :
                        <div className="pro-info">
                            <div className="tit">{data.title}</div>
                            {data.desc && <div className="des">{data.desc}</div>}
                            <div className="tags">
                                {(data.tagInfos || []).map(item => <div className="tags-item">{item.title}</div>)}
                            </div>
                            {/* <div className="tickets">
                                <div className="tickets-item">
                                    <div className="type">旅行券</div>
                                    <div className="line"></div>
                                    <div className="tickets-info">满1000减20</div>
                                    <div className="c1"></div>
                                    <div className="c2"></div>
                                </div>
                            </div> */}
                            <div className="price-info">
                                <div className="price">&yen;<span className="num">{data.taocanPrice ? data.taocanPrice : data.price}</span>起</div>
                                <div className={`btn ${data.status === 2 ? 'soldout' : ''}`} >{btnText}</div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default ProductItem;